module.exports = {
      id: "news-usage",
      viewBox: "0 0 24.597 24.597",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#news",
      toString: function () {
        return this.url;
      }
    }